// extracted by mini-css-extract-plugin
export default {"card":"GestaoModulos_card__nPIw3","title":"GestaoModulos_title__LkcIG","actionsHeader":"GestaoModulos_actionsHeader__61Dpb"};